import { Component, HostListener, OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from 'src/app/entities/service';
import { ServiceService } from 'src/app/services/service.service';
import { AuthService } from 'src/app/services/auth.service';
import { NavigationStart, NavigationEnd, Event as NavigationEvent, Router } from '@angular/router';
import { SharedService } from 'src/app/services/sharedService';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ProcessService } from 'src/app/services/process.service';
import {AdminService} from "../../services/admin.service";

@Component({
  selector: 'app-fusion-nav-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit, OnDestroy {
  leftMenuItems = [];
  leftMenuSubscription: any;
  @Input() contextMenu: string[];
  lang: string;
  username: string;
  initials: string;
  menuItems: string[][];
  lanList;
  user;
  services: Service[];
  dropDownNotifications: any[];
  unseenNotifications = 0;
  loginSubscription: any;
  isAssigned = false
  controlsModuleEnabled = false
  mobileMenuOpen = false;
  servicesExpanded = false;
  adminExpanded = false;
  sidenavOpen = false;
  currentUrl: string = '';

  get isServicesRoute(): boolean {
    return this.getMenuKeyFromUrl(this.currentUrl) === 'services';
  }

  get isAdminRoute(): boolean {
    return this.getMenuKeyFromUrl(this.currentUrl) === 'admin';
  }
  constructor(public translate: TranslateService, public serviceService: ServiceService,
              public userService: UserService, public notificationService: NotificationService,
              public auth: AuthService, public router: Router, public sharedService: SharedService,
              public processService: ProcessService,
              private settings: AdminService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    // translate.use('en');
    this.setLang(localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en');
    this.auth.loggedIn.subscribe(val => {
      if (val) {
        this.processService.isAssigned().subscribe(res => {
          if (res.is_assigned){
            this.isAssigned = true;
          }
          this.loadData();
        })
        
      }
    });
    this.settings.modules$().subscribe(configuration => {
      this.controlsModuleEnabled = configuration?.modules?.controls ?? false;
    })
  }

  loadData() {
        this.userService.getCurrentUser().subscribe(user => {
          if (user !== null) {
            this.user = user;
            this.getServices();
            this.updateSidenavFromUrl(this.currentUrl);
          }
        });
  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.updateSidenavFromUrl(this.currentUrl);
    this.leftMenuSubscription = this.sharedService.menuItemsEmitter.subscribe(menuItems => {
      this.setupMenu(menuItems);
    });
    this.router.events
      .subscribe(
        (event: NavigationEvent) => {
          if (event instanceof NavigationEnd) {
            this.currentUrl = event.urlAfterRedirects;
            this.updateSidenavFromUrl(event.urlAfterRedirects);
          }
          if (event instanceof NavigationStart) {
            this.closeMobileMenu();
          }
        });
    // this.userService.getCurrentUser().subscribe(user => {
    //   if (user!==null){
    //     this.user = user;
    //   this.getServices()
    //   }

    // })
    this.getUnseenNotifications();
    // Poll only while the tab is visible; an inactive tab makes no requests.
    this.unseenTimer = setInterval(() => {
      if (!document.hidden) { this.getUnseenNotifications(); }
    }, 60000);
    // Returning to the tab refreshes immediately instead of waiting a tick.
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  ngOnDestroy() {
    clearInterval(this.unseenTimer);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  private unseenTimer: any;
  private onVisibilityChange = () => {
    if (!document.hidden) { this.getUnseenNotifications(); }
  };

  getUnseenNotifications() {
    this.notificationService.getUnseenCount().subscribe(count => {
      this.unseenNotifications = count['count'];
    });
  }
  
  navigateToNotifications() {
    this.router.navigate(['notifications']);
  }
  navigateToNotification(value) {
    const route = value.referenceObject ? '/proposal/' + value.referenceObject.id + '/' + value.referenceObject.key : 'notifications';
    this.router.navigate([route]);
  }

  setSeenAll() {
    this.unseenNotifications = 0;

    this.notificationService.setSeenAll().subscribe(result => {
      this.notificationService.getNotificationList().subscribe(res => {
        this.dropDownNotifications = res;
       });
    });
  }

  getServices() {
    this.serviceService.getTotalServiceList('').subscribe(services => {
      this.services = services;
    });
  }

  logout() {
    this.username = '';
    this.auth.logout().subscribe(res => {
      this.router.navigate(['login']);
      this.auth.setLoginStatus(false);
    });
  }

  userAccount() {
    this.router.navigate(['user', this.user.id]);
  }

  setupMenu(menuItems) {
    if (menuItems !== 'services') {
      this.leftMenuItems = menuItems;
    } else {
      this.serviceService.getTotalServiceList('').subscribe(services => {
        this.leftMenuItems = [];
        services.forEach(service => {
          this.leftMenuItems.push({ title: service.name, link: '/csv-list/' + service.id });
        });
      });
    }
  }

  setLang(lang) {
    this.sharedService.setLan(lang);
    this.lang = lang;
    this.translate.use(lang);
  }

  isMenuItemActive(menuItem: any): boolean {
    const url = this.currentUrl.split('?')[0];
    const matches = url === menuItem.link || url.startsWith(menuItem.link + '/');
    if (!matches) return false;
    return !this.leftMenuItems.some(other =>
      other !== menuItem &&
      other.link.startsWith(menuItem.link) &&
      (url === other.link || url.startsWith(other.link + '/'))
    );
  }

  private getMenuKeyFromUrl(url: string): string | null {
    if (url.startsWith('/csv-list')) return 'services';
    if (url.startsWith('/company')) return 'company';
    if (url.startsWith('/home')) return 'home';
    if (url === '/indicator' || url.startsWith('/indicator/')) return 'indicator';
    if (url.startsWith('/report')) return 'report';
    if (url === '/help') return 'help';
    if (url === '/user' || url.startsWith('/user?')) return 'admin';
    if (url.startsWith('/user/')) return 'user-profile';
    const adminPrefixes = ['/ext-api', '/service', '/batch-process',
      '/dashboard', '/currency', '/payee-sector', '/regional-officer',
      '/indicator-sectors', '/control-team', '/admin', '/help-editor'];
    if (adminPrefixes.some(p => url.startsWith(p))) return 'admin';
    return null;
  }

  private updateSidenavFromUrl(url: string) {
    const key = this.getMenuKeyFromUrl(url);
    if (key === 'user-profile') {
      if (this.user?.roles?.includes('ADMIN')) {
        this.setupMenu(this.sharedService.allMenuItems['admin'] || []);
      } else {
        this.setupMenu([{ title: 'HEADER.USER_PROFILE', link: '/user/' + this.user?.id }]);
      }
    } else {
      this.setupMenu(key !== null ? (this.sharedService.allMenuItems[key] || []) : []);
    }
  }

  openControlModule() {
    window.open(window.location.origin + '/control-module');
  }

  private setScrollLock(locked: boolean) {
    const value = locked ? 'hidden' : '';
    document.body.style.overflow = value;
    document.documentElement.style.overflow = value;
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    this.setScrollLock(this.mobileMenuOpen);
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
    this.sidenavOpen = false;
    this.servicesExpanded = false;
    this.adminExpanded = false;
    this.setScrollLock(false);
  }

  toggleSidenav() {
    this.sidenavOpen = !this.sidenavOpen;
    if (this.sidenavOpen) {
      this.mobileMenuOpen = false;
      this.servicesExpanded = false;
      this.adminExpanded = false;
    }
    this.setScrollLock(this.sidenavOpen);
  }

  closeSidenav() {
    this.sidenavOpen = false;
    this.setScrollLock(false);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth >= 1200) {
      if (this.mobileMenuOpen || this.sidenavOpen) {
        this.closeMobileMenu();
      }
    }
  }

}
